import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { DeleteMessagingStreamingConfigurations } from "../schemas/schemas_0";
export { $Command };
export class DeleteMessagingStreamingConfigurationsCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("ChimeMessagingService", "DeleteMessagingStreamingConfigurations", {})
    .n("ChimeSDKMessagingClient", "DeleteMessagingStreamingConfigurationsCommand")
    .sc(DeleteMessagingStreamingConfigurations)
    .build() {
}
